var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Edit50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E57373",
    d: "M42.583,9.067l-3.651-3.65c-0.555-0.556-1.459-0.556-2.015,0l-1.718,1.72l5.664,5.664l1.72-1.718C43.139,10.526,43.139,9.625,42.583,9.067"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9800",
    d: "M4.465 21.524H40.471999999999994V29.535H4.465z",
    transform: "rotate(134.999 22.469 25.53)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0BEC5",
    d: "M34.61 7.379H38.616V15.392H34.61z",
    transform: "rotate(-45.02 36.61 11.385)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M6.905 35.43L5 43 12.571 41.094z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474F",
    d: "M5.965 39.172L5 43 8.827 42.035z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Edit50);
export default __webpack_public_path__ + "static/media/icons8-edit-50.531909f19422bcf3e3804918d1cd995e.svg";
export { ForwardRef as ReactComponent };